<template>
  <div>
    <b-card>
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h5 class="mb-0">Alertas y excepciones</h5>
        <b-form-select v-model="statusFilter" :options="statusOptions" size="sm" style="width:180px"
          @change="load"></b-form-select>
      </div>
      <b-table
        striped hover responsive small show-empty
        :busy="loading"
        :items="rows"
        :fields="fields"
        empty-text="Sin alertas."
      >
        <template #table-busy>
          <div class="text-center text-primary my-3"><b-spinner></b-spinner></div>
        </template>
        <template #cell(severity)="d">
          <b-badge :variant="sevVariant(d.item.severity)">{{ d.item.severity }}</b-badge>
        </template>
        <template #cell(status)="d">
          <b-badge :variant="statusVariant(d.item.status)">{{ d.item.status }}</b-badge>
        </template>
        <template #cell(actions)="d">
          <b-button size="sm" variant="outline-primary" class="mr-1"
            @click="setStatus(d.item, 'acknowledged')">Asignarme</b-button>
          <b-button size="sm" variant="outline-success"
            @click="setStatus(d.item, 'resolved')">Resolver</b-button>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import executiveService from '@/services/executiveService';
import { mapGetters } from 'vuex';

// Pestaña 14 · Auditoría, alertas y excepciones (doc 04 §3, reporte 13). Asignar/resolver.
export default {
  name: 'ExecAlerts',
  props: { filters: { type: Object, default: () => ({}) } },
  data() {
    return {
      loading: false,
      rows: [],
      statusFilter: 'open',
      statusOptions: [
        { value: '', text: 'Todas' },
        { value: 'open', text: 'Abiertas' },
        { value: 'acknowledged', text: 'Asignadas' },
        { value: 'resolved', text: 'Resueltas' }
      ],
      fields: [
        { key: 'alert_type', label: 'Tipo' },
        { key: 'severity', label: 'Severidad' },
        { key: 'title', label: 'Descripción' },
        { key: 'sucursal_id', label: 'Sucursal' },
        { key: 'status', label: 'Estatus' },
        { key: 'created_at', label: 'Detectada' },
        { key: 'actions', label: '' }
      ]
    };
  },
  computed: {
    ...mapGetters('api', ['loginInfo']),
    userId() {
      return this.loginInfo && this.loginInfo.user ? this.loginInfo.user.id : null;
    }
  },
  watch: {
    filters: { deep: true, handler() { this.load(); } }
  },
  mounted() { this.load(); },
  methods: {
    load() {
      this.loading = true;
      const f = Object.assign({}, this.filters);
      if (this.statusFilter) f.status = this.statusFilter;
      executiveService.run('alerts', f)
        .then((res) => { this.rows = (res.data && res.data.rows) || []; })
        .catch((err) => this.$emit('error', err))
        .finally(() => { this.loading = false; });
    },
    setStatus(item, status) {
      const payload = { status };
      if (status === 'acknowledged' && this.userId) payload.assigned_user_id = Number(this.userId);
      executiveService.updateAlert(item.id, payload)
        .then(() => this.load())
        .catch((err) => this.$emit('error', err));
    },
    sevVariant(s) {
      const v = (s || '').toLowerCase();
      if (v === 'high' || v === 'critical') return 'danger';
      if (v === 'medium') return 'warning';
      return 'secondary';
    },
    statusVariant(s) {
      const v = (s || '').toLowerCase();
      if (v === 'resolved' || v === 'closed') return 'success';
      if (v === 'acknowledged') return 'primary';
      return 'warning';
    }
  }
}
</script>
